export default __webpack_public_path__ + "static/media/machine.d080fc2d.mp4";